import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28fb2fc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "track-number form-item-cell" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "物品信息"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, " Cargo Information ")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "product-info",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navProductList && _ctx.navProductList(...args)))
    }, [
      (_ctx.products.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 点击填写物品信息 "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " 共计" + _toDisplayString(_ctx.products.length) + "件物品 ", 1)),
      _createVNode(_component_Icon, { icon: "btn_arrow_right" })
    ])
  ]))
}